// assets/live-view-counter.js

(function () {
  // Converte para inteiro com fallback seguro
  function safeInt(value, fallback) {
    var n = parseInt(value, 10);
    return isNaN(n) ? fallback : n;
  }

  function clamp(n, min, max) {
    if (n < min) return min;
    if (n > max) return max;
    return n;
  }

  function initLiveView(el) {
    // Evita inicializar duas vezes o mesmo elemento
    if (el.dataset.liveViewInitialized === 'true') return;
    el.dataset.liveViewInitialized = 'true';

    var path = window.location.pathname;
    var stepKey = String(el.dataset.step || '0');
    var viewerKey = 'viewer_count_' + path + '_' + stepKey;
    var timestampKey = 'viewer_count_timestamp_' + path + '_' + stepKey;
    var now = Date.now();
    var maxAge = 10 * 60 * 1000; // 10 minutos

    // Lê min/max do data-*, com fallback seguro
    // Se der qualquer problema, cai num range 15–35 (exemplo) em vez de 0
    var min = safeInt(el.dataset.min, 15);
    var max = safeInt(el.dataset.max, 35);

    // Garante que max >= min
    if (max < min) {
      max = min;
    }

    // Intervalo em segundos (fallback 10s)
    var intervalTime = safeInt(el.dataset.interval, 10) * 1000;
    if (intervalTime < 1000) intervalTime = 1000; // nunca menos que 1s

    var storedCount = safeInt(localStorage.getItem(viewerKey), NaN);
    var storedTime = safeInt(localStorage.getItem(timestampKey), 0);
    var viewerCount;

    // Variação entre -3 e +3
    var variation = Math.floor(Math.random() * 7) - 3;

    // Se temos valor salvo recente, reaproveita com variação
    if (!isNaN(storedCount) && storedTime && (now - storedTime) < maxAge) {
      viewerCount = clamp(storedCount + variation, min, max);
    } else {
      // Primeiro load ou cache velho: gera novo dentro do range
      viewerCount = clamp(
        Math.floor(Math.random() * (max - min + 1)) + min,
        min,
        max
      );
    }

    // Segurança extra: se por algum motivo ainda der NaN, usa min
    if (!isFinite(viewerCount)) {
      viewerCount = min;
    }

    localStorage.setItem(viewerKey, String(viewerCount));
    localStorage.setItem(timestampKey, String(now));

    var viewerEl = el.querySelector('.viwer_pro');
    if (viewerEl) {
      viewerEl.textContent = String(viewerCount);
    }

    function tick() {
      variation = Math.floor(Math.random() * 7) - 3;
      viewerCount = clamp(viewerCount + variation, min, max);

      if (viewerEl) {
        viewerEl.textContent = String(viewerCount);
      }

      localStorage.setItem(viewerKey, String(viewerCount));
      localStorage.setItem(timestampKey, String(Date.now()));
    }

    setInterval(tick, intervalTime);

    // Quando mudar o passo do conjunto, re-aplica o valor que está no localStorage
    document.addEventListener('conjunto:step-change', function () {
      var current = safeInt(localStorage.getItem(viewerKey), NaN);
      var valueToShow = !isNaN(current) ? current : viewerCount;
      if (viewerEl) {
        viewerEl.textContent = String(valueToShow);
      }
    });
  }

  function initAllLiveViews() {
    var containers = document.querySelectorAll('.live-view__container');
    containers.forEach(initLiveView);
  }

  // Inicializa no load normal
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllLiveViews);
  } else {
    initAllLiveViews();
  }

  // Reativa ao voltar usando botão "voltar" (bfcache)
  window.addEventListener('pageshow', function (event) {
    if (event.persisted) {
      initAllLiveViews();
    }
  });
})();
